import { Address } from "../models"

export const ShipmentTypes = {
	CARRY: "Mitnahme",
	POST: "Post",
	EMAIL: "Print@Home",
	PICKUP: "Abholung"
}

export const ShipmentTypesBoxOffice = {
	CARRY: "Mitnahme"
}

// for Box office is CARRY always default
export const DefaultShipmentTypeBoxOffice = "CARRY"

export const PaymentTypes = {
	CASH: "Bar",
	CASH_DEBITCARD: "Bar - EC",
	CASH_MASTERCARD: "Bar - Mastercard",
	CASH_VISA: "Bar - Visa",
	CREDITCARD: "Kreditkarte",
	SEPADEBIT: "Lastschrift",
	PAYPAL: "Paypal",
	INVOICE: "Rechnung",
	SOFORT: "Sofortüberweisung",
	BANKWIRE: "Überweisung",
	PAYPAL_PLUS: "PayPal Plus",
	REGISTRATION: 'Anmeldung',
}

export const PaymentTypesBoxOffice = {
	CASH: "Bar",
	CASH_DEBITCARD: "Bar - EC",
	CASH_MASTERCARD: "Bar - Mastercard",
	CASH_VISA: "Bar - Visa"
}

// for Box office is CASH always default
export const DefaultPaymentTypeBoxOffice = "CASH"

export const CurrencyEnum = {
	EUR: "€",
}

export class DocumentsToPrint {
	invoicePrint: boolean;
	coverLetterPrint: boolean;
	ticketPrint: boolean;
	pdfTickets?: boolean;
}

export class ErrorMessages {
	paymentErrors: string[];
	shipmentErrors: string[];
	ticketPrinterErrors: string[];
}

export class Checkout {
	id: string;
	shoppingCartId: string;
	billingAddress: Address;
	shippingAddress: Address;
	paymentType: string;
	shipmentType: string;
}



// WEBPACK FOOTER //
// ./src/app/models/checkout.model.ts